import Button from "./Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-solid-svg-icons";
import {CloseButtonType} from "./ButtonTypes";
import {ColourMod} from "../../Data/Enums/LayoutEnums";
import {ButtonSize} from "../../Data/Enums/Generic";

const CloseButton = (props: CloseButtonType) => {
    return (
        <Button
            title={'Close'}
            onClick={() => props.onClick()}
            size={props.size ?? ButtonSize.Default}
            colour={props.colour ?? ColourMod.Alert}
            icon={<FontAwesomeIcon icon={faXmark} fixedWidth={true}/>}
            iconOnly={true}
        />
    )
}

export default CloseButton